import React, { useEffect, useState } from 'react';
import { withStore } from 'contexts/store-context';
import { withToast } from 'contexts/toast-context';
import ChargeList from 'components/charge/charge-list';
import Empty from 'components/misc/empty';
import PaginationWrapper from 'components/bootstrap/pagination-wrapper';
import { SectionBlock, SectionTitle, SectionBody, SectionFooter } from 'components/blocks/section-blocks';
import { LoadingSkeleton } from 'components/loading/loading-skeleton';
import { Row, Col } from 'reactstrap';
import { isEmpty } from 'utils/helpers';

const ChargeSection = (props) => {
  const { type, model = [], bookingId, store, toast, dataLoading = false } = props;
  const [ charges, setCharges ] = useState([]);
  const [ page, setPage ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const [ sortProp, setSortProp ] = useState('');
  const [ sortValue, setSortValue ] = useState('');
  const [ loading, setLoading ] = useState(false);


  // Hooks
  useEffect(() => {
    dataLoading ? fetchData() : setCharges(model);
  }, [model, page, pageSize]);


  // Methods
  const fetchData = async () => {
    try {
      setLoading(true);
      let model = await store.query('charge', params());
      let filteredModel = model.filter(c => c.reason != 'tip');
      setCharges(filteredModel);
    } catch(e) {
      toast.showError(e);
    } finally {
      setLoading(false);
    }
  }

  const params = () => {
    let params = {};
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    if (sortProp) params.sortProp = sortProp;
    if (sortValue) params.sortValue = sortValue;
    params.include = 'card'
    return params;
  }


  // Render
  return (
    <SectionBlock>
      <SectionTitle title='Charges' className='flex-between' />
      <SectionBody>
        <ChargeList charges={charges} loading={loading} />
      </SectionBody>
      <SectionFooter>
        <PaginationWrapper meta={charges.meta} setPage={v => setPage(v)} />
      </SectionFooter>
    </SectionBlock>
  )
}

export default withStore(withToast(ChargeSection));
